import { mixed, number, object, string } from 'yup';

export const deviceValidationSchema = object().shape({
  model_id: number().required('fillField'),
  imei: string().required('fillField'),
  machinery_id: mixed().notRequired(),
  fuel_level_key: string().notRequired(),
  fuel_level_calibration_id: number().notRequired(),
  fuel_consumption_key: string().notRequired(),
  fuel_consumption_calibration_id: number().notRequired(),
  mileage_key: string().notRequired(),
  mileage_calibration_id: number().notRequired(),
});
